
































import Vue from 'vue'
export default Vue.extend({
  computed: {
    isMemberLoggedIn(): boolean {
      return !!this.$store.state.memberId || !!this.$store.state.submitMemberId
    },
    isVisiterLoggedIn(): boolean {
      return !!this.$store.state.user.uid
    },
    memberSignOutUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/sign-out`
    },
    visiterSignInUrl(): string {
      return `/tensaku_visiter/sign_in/${this.$store.state.examInfo.examGroupKey}`
    },
    // ロゴがクリックされた時の遷移先
    logoUrl() {
      // 非会員ログイン画面の場合
      if (this.$route.path === '/tensaku_visiter/sign_in') {
        return `/tensaku_visiter/sign_in`
      }
      // 非会員の場合
      if (this.isVisiterLoggedIn) {
        return `/tensaku_visiter/`
      }
      // 会員の場合
      else {
        return `${process.env.VUE_APP_ROOT_PATH}/participant/my-page`
      }

    }
  },
  methods: {
    memberSignOut() {
      this.$store.dispatch('deleteAuth')
      window.location.href = this.memberSignOutUrl
      // この先でcookie削除された上で会員用ログインURLへリダイレクトする
    },
    visiterSignOut() {
      this.$store.dispatch('deleteAuth')
      this.$router.push(this.visiterSignInUrl)
    }
  }
})
